module.exports = __webpack_public_path__ + "img/notifications.b71867a1.png";